import { render, staticRenderFns } from "./WorkflowIframe.vue?vue&type=template&id=59d23ab2&scoped=true"
import script from "./WorkflowIframe.vue?vue&type=script&lang=js"
export * from "./WorkflowIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d23ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d23ab2')) {
      api.createRecord('59d23ab2', component.options)
    } else {
      api.reload('59d23ab2', component.options)
    }
    module.hot.accept("./WorkflowIframe.vue?vue&type=template&id=59d23ab2&scoped=true", function () {
      api.rerender('59d23ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/WorkflowIframe.vue"
export default component.exports